import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type Strings = {
  title: string;
  content: string | JSX.Element;
  confirm?: string;
  cancel?: string;
};

type Props = {
  strings: Strings;
  open: boolean;
  onConfirm(): void;
  onCancel?(): void;
};

export const InfoDialog: React.FC<Props> = ({ open, strings, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>
        <Typography variant="h6">{strings.title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          {strings.content}
        </Typography>
        <DialogActions>
          {onCancel && (
            <Button onClick={onCancel} color="primary">
              {strings.cancel || t('subscriber:common.close', 'Close')}
            </Button>
          )}
          <Button onClick={onConfirm} color="primary">
            {strings.confirm || t('subscriber:common.ok', 'OK')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
